<div class="app-root">
  <!-- Simple Player Layer (Bottom) -->
  <div
    class="simple-player-container"
    [style.visibility]="showSimplePlayer ? 'visible' : 'hidden'"
  >
    <app-simple-player></app-simple-player>
  </div>

  <!-- App Container Layer (Middle) -->
  <div class="app-container">
    <div class="content-layer">
      <app-shimmer-router-outlet></app-shimmer-router-outlet>
    </div>
  </div>

  <!-- No Internet Info Layer (Top) -->
  <app-no-internet
    class="no-internet-info"
    [isNoInternet]="isNoInternet"
    [ngStyle]="{ visibility: isNoInternet ? 'visible' : 'hidden' }"
  ></app-no-internet>
</div>
